/* istanbul ignore file */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Suspense, useMemo, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from '@shared/components/LoadingSpinner';
const withSuspense = (Component)=>{
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(LoadingSpinner, {}),
        children: Component
    });
};
export function useClientRoutes(options) {
    const { routes } = options;
    const [localeRoutes, ...otherRoutes] = routes;
    const location = useLocation();
    const [ssrEntry] = useState(()=>location.pathname);
    const isEmbedded = useSelector((state)=>state.config.isEmbedded);
    return useMemo(()=>{
        const children = localeRoutes.children.map((route)=>{
            var _matchingPath_pattern;
            var _route_path;
            const path = `/:locale/${(_route_path = route.path) !== null && _route_path !== void 0 ? _route_path : ''}`;
            const matchingPath = matchPath(path, ssrEntry);
            const shouldWrapWithSuspense = isEmbedded || !(route.index || (matchingPath === null || matchingPath === void 0 ? void 0 : (_matchingPath_pattern = matchingPath.pattern) === null || _matchingPath_pattern === void 0 ? void 0 : _matchingPath_pattern.path) === path);
            return _object_spread_props(_object_spread({}, route), {
                element: shouldWrapWithSuspense ? withSuspense(route.element) : route.element
            });
        });
        return [
            _object_spread_props(_object_spread({}, localeRoutes), {
                children
            }),
            ...otherRoutes
        ];
    }, [
        ssrEntry,
        routes,
        isEmbedded
    ]);
}
